/**
 * Program 12.1 UX3 — Lead → Opportunity conversion preview modal.
 */
import React from 'react';
import { Alert, List, Modal, Typography } from 'antd';
import type { Lead } from '@/services/lead.service';
import { leadConversionCarryForward, leadConversionRequires } from './leadReadiness';

const { Text } = Typography;

export type LeadConversionPreviewModalProps = {
  open: boolean;
  lead: Lead | null;
  checkpointAllPass?: boolean;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const LeadConversionPreviewModal: React.FC<LeadConversionPreviewModalProps> = ({
  open,
  lead,
  checkpointAllPass,
  loading,
  onCancel,
  onConfirm,
}) => {
  if (!lead) return null;
  const row = lead as unknown as Record<string, unknown>;
  const carry = leadConversionCarryForward(row);
  const requires = leadConversionRequires();

  return (
    <Modal
      title="Convert to Opportunity"
      open={open}
      onCancel={onCancel}
      onOk={onConfirm}
      okText="Create Opportunity"
      confirmLoading={loading}
      okButtonProps={{ disabled: checkpointAllPass === false }}
    >
      <Text>
        From: <strong>{lead.customer_name}</strong> ({lead.lead_number})
      </Text>
      <List
        size="small"
        header="Will carry forward"
        dataSource={carry}
        renderItem={(item) => <List.Item>✓ {item}</List.Item>}
        style={{ marginTop: 12 }}
      />
      <List
        size="small"
        header="Requires completion"
        dataSource={requires}
        renderItem={(item) => <List.Item>• {item}</List.Item>}
        style={{ marginTop: 8 }}
      />
      {checkpointAllPass === false && (
        <Alert
          type="warning"
          showIcon
          style={{ marginTop: 12 }}
          message="Complete the enterprise decision checkpoint before converting."
        />
      )}
    </Modal>
  );
};

export default LeadConversionPreviewModal;
